import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Tab } from '@mui/material';
import React from 'react';

import { SeamRequest } from 'app/model/seam-request';
import { ImpactReportList } from 'features/seam/request/qa/impact-report-list';

import { PatternOverlapChecker } from './pattern-overlap-checker';

interface DataQualityProps {
    request: SeamRequest;
}

export const DataQuality: React.FunctionComponent<DataQualityProps> = (props) => {
    const [value, setValue] = React.useState('1');

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    return (
        <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleChange} aria-label='lab API tabs example'>
                    <Tab label='Overlap Checker' value='1' />
                    <Tab label='Impact' value='2' />
                </TabList>
            </Box>
            <TabPanel value='1'>
                <PatternOverlapChecker request={props.request} />
            </TabPanel>
            <TabPanel
                value='2'
                sx={{ flex: '1 1 auto', display: 'flex', flexDirection: 'column', padding: 0, paddingTop: 1 }}
            >
                <ImpactReportList />
            </TabPanel>
        </TabContext>
    );
};
